import React from 'react'
import {
  ETF_FUND,
  FUTURE_SCHOLAR_529,
  MUTUAL_FUND,
  ETF_INDEX_FUND,
  VARIABLE_FUND,
  CLOSED_END_FUND,
  MODEL_PORTFOLIOS,
} from '../../../Helpers/FundTypes.js'

export function getFundHeaderTitle(fund) {
  const { fundHeader, name } = fund
  const { fundName, symbol } = fundHeader

  let h1 = null

  const classes =
    'u-alignBaseline u-marginLeft2gu u-textNormal u-textSizeMsrp3 u-textSecondary'

  // TODO: HACK: Ensure registerd trademark after Beta Advantage
  const _fundName = fundName
    ? fundName.replace('Beta Advantage ', 'Beta Advantage® ')
    : ''

  if (fund.fundGroup === ETF_FUND || fund.fundGroup === ETF_INDEX_FUND) {
    h1 = (
      <h1 id="fundHeader-title" className="u-textColorWhite u-textSizeMsrp3">
        {symbol}
        <span className={classes}>{_fundName}</span>
      </h1>
    )
  } else if (fund.fundGroup === FUTURE_SCHOLAR_529) {
    h1 = (
      <h1 id="fundHeader-title" className="u-textColorWhite u-textSizeMsrp3">
        {_fundName}
        <span className={classes}>Future Scholar Plan</span>
      </h1>
    )
  } else {
    h1 = (
      <h1 id="fundHeader-title" className="u-textColorWhite u-textSizeMsrp3">
        {fund.fundGroup === MODEL_PORTFOLIOS ? name : _fundName}
        <span className={classes}>{symbol}</span>
      </h1>
    )
  }

  return h1
}

export function getOpenMessage(showOtherFunds, fundGroup) {
  const hideShow = showOtherFunds ? 'Hide' : 'Show'

  let message = ''
  switch (fundGroup) {
    case ETF_FUND:
    case ETF_INDEX_FUND:
      message = hideShow + ' other ETFs'
      break
    case FUTURE_SCHOLAR_529:
      message = hideShow + ' other 529 Portfolios'
      break
    case MUTUAL_FUND:
      message = hideShow + ' other Mutual Funds'
      break
    case VARIABLE_FUND:
      message = hideShow + ' other Variable Products'
      break
    case CLOSED_END_FUND:
      message = hideShow + ' other Closed End Funds'
      break
    case MODEL_PORTFOLIOS:
      message = hideShow + ' other Model Portfolios'
      break
  }
  return message
}
